module.exports = __webpack_public_path__ + "media/fonts/BasisGrotesquePro-BlackItalic-f5df1b54e385e131f5b76b7d79d45285.woff";